import { withABTestParticipate } from '@jusbrasil-web/shared-ab-test'
import { setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'
import { GetServerSidePropsContext } from 'next'

import {
  AUTH_BACKEND_UPSTREAM_ARGOS,
  AUTH_BACKEND_UPSTREAM_COOKIE,
  AUTH_BACKEND_UPSTREAM_COOKIE_TTL_SECONDS,
  AUTH_BACKEND_UPSTREAM_VARIANTS,
  AuthBackendUpstreamVariant,
} from './constants'

const VALID_VARIANTS = new Set<string>(Object.values(AUTH_BACKEND_UPSTREAM_VARIANTS))

function mapToVariant(
  participating: boolean,
  alternative: string | null | undefined
): AuthBackendUpstreamVariant {
  if (!participating) return AUTH_BACKEND_UPSTREAM_VARIANTS.NOT_PARTICIPATING
  if (alternative === AUTH_BACKEND_UPSTREAM_VARIANTS.CONTROL)
    return AUTH_BACKEND_UPSTREAM_VARIANTS.CONTROL
  if (alternative === AUTH_BACKEND_UPSTREAM_VARIANTS.AUTH_SERVER)
    return AUTH_BACKEND_UPSTREAM_VARIANTS.AUTH_SERVER
  return AUTH_BACKEND_UPSTREAM_VARIANTS.NOT_PARTICIPATING
}

export function commitAuthMigrationVariant(
  ctx: GetServerSidePropsContext,
  variant: AuthBackendUpstreamVariant
): void {
  setJusbrasilCookie(ctx.res, AUTH_BACKEND_UPSTREAM_COOKIE, variant, {
    maxAge: AUTH_BACKEND_UPSTREAM_COOKIE_TTL_SECONDS,
    sameSite: 'lax',
    httpOnly: true,
    secure: process.env.NODE_ENV === 'production',
    path: '/',
  })
}

export async function withAuthMigrationExperiment(
  ctx: GetServerSidePropsContext,
  options: { commit?: boolean } = {}
): Promise<AuthBackendUpstreamVariant> {
  const { commit = true } = options
  const existing = ctx.req.cookies?.[AUTH_BACKEND_UPSTREAM_COOKIE]
  if (existing && VALID_VARIANTS.has(existing)) {
    return existing as AuthBackendUpstreamVariant
  }

  try {
    const result = await withABTestParticipate(ctx, AUTH_BACKEND_UPSTREAM_ARGOS)
    const variant = mapToVariant(result.participating, result.alternative)
    if (commit) commitAuthMigrationVariant(ctx, variant)

    return variant
  } catch {
    return AUTH_BACKEND_UPSTREAM_VARIANTS.NOT_PARTICIPATING
  }
}
